import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { Box, Button, TextField, Typography, IconButton, useMediaQuery } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

interface FormData {
  name: string;
  email: string;
  message: string;
}

interface FormErrors {
  name?: string;
  email?: string;
  message?: string;
}

function ContactMe() {
  const formRef = useRef<HTMLFormElement | null>(null);
  const [formData, setFormData] = useState<FormData>({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState<FormErrors>({});
  const isMdScreen = useMediaQuery("(max-width:1200px)");
       const isXsScreen = useMediaQuery("(max-width:600px)");
  const validateField = (name: string, value: string) => {
    let errorMsg = "";

    if (!value.trim()) {
      errorMsg = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    } else if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        errorMsg = "Please enter a valid email address";
      }
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMsg }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const newErrors: FormErrors = {};
    Object.keys(formData).forEach((key) => {
      validateField(key, formData[key as keyof FormData]);
      if (!formData[key as keyof FormData].trim()) {
        newErrors[key as keyof FormErrors] = `${key.charAt(0).toUpperCase() + key.slice(1)} is required`;
      }
    });

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }

    emailjs
      .sendForm(
        "service_xtp4seh",
        "template_4qnh5kb",
        formRef.current!,
        "-C19c8QoOO5kJW0qC"
      )
      .then(
        (result) => {
          console.log("Email Sent Successfully:", result.text);
          alert("Message sent successfully!");
          setFormData({ name: "", email: "", message: "" });
          setErrors({});
        },
        (error) => {
          console.log("Error Sending Email:", error.text);
          alert("Failed to send message, please try again.");
        }
      );
  };

  return (
    <section id="contactMe" style={{ height: isMdScreen ? "auto" : "100vh", paddingTop: isMdScreen ? "20px": 0 ,paddingBottom : isMdScreen ? "20px": 0 , display:"flex",alignItems:"center", background: "linear-gradient(124deg, rgba(0, 0, 0, 1) 50%, rgba(128, 0, 128, 0.6) 100%)" }}>
     <Box
  display="flex"
  flexDirection="column"
  alignItems="center"
  justifyContent="center"
  width={isXsScreen ? "80%" : "90%"}
  marginLeft="auto"
  marginRight="auto" // Centering horizontally
  sx={{
    marginTop: 1,
    padding: "0 20px", // Optional: Add padding to avoid content sticking to edges
  }}
>
<Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: 3, color: "white" }}>
    Contact Me
  </Typography>
        <Typography variant="h6" sx={{ marginBottom: 3, textAlign: "center", color: "white" }}>
          Feel free to reach out to me. I'll get back to you as soon as possible!
        </Typography>

        {/* LinkedIn Info */}
        <Box display="flex" alignItems="center" sx={{ marginBottom: 1 }}>
          <Typography variant="body1" sx={{ color: "white", marginRight: 1 }}>
            You can find me on LinkedIn or send a direct email:
          </Typography>
          <IconButton
            component="a"
            href="https://www.linkedin.com/in/shizza-saqib-35981119b/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "blue" }}
          >
            <LinkedInIcon fontSize="large" />
          </IconButton>
        </Box>

        <Box component="form" ref={formRef} onSubmit={handleSubmit} noValidate autoComplete="off">
          <TextField
            fullWidth
            label="Your Name"
            variant="outlined"
            name="name"
            value={formData.name}
            onChange={handleChange}
            error={!!errors.name}
            helperText={errors.name}
            sx={{ marginBottom: 2, backgroundColor: "white" }}
            required
          />
          <TextField
            fullWidth
            label="Your Email"
            variant="outlined"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
            sx={{ marginBottom: 2, backgroundColor: "white" }}
            required
          />
          <TextField
            fullWidth
            label="Your Message"
            variant="outlined"
            name="message"
            multiline
            rows={4}
            value={formData.message}
            onChange={handleChange}
            error={!!errors.message}
            helperText={errors.message}
            sx={{ marginBottom: 3, backgroundColor: "white" }}
            required
          />
          <Button variant="contained" color="primary" fullWidth type="submit">
            Send Message
          </Button>
        </Box>
      </Box>
    </section>
  );
}

export default ContactMe;
